import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { ConfiguracaoCaixaApiService } from '../../../services/configuracao-caixa-api.service';
import { MessageService } from '@services/message.service';
import { ContaCaixaConfiguracao } from '../../../models/conta-caixa-configuracao';

@Component({
  selector: 'app-trava-conta-caixa-dialog',
  standalone: false,
  templateUrl: './trava-conta-caixa-dialog.component.html',
  styleUrl: './trava-conta-caixa-dialog.component.scss'
})
export class TravaContaCaixaDialogComponent implements OnInit {

  conta!: ContaCaixaConfiguracao;

  dataTrava: Date | null = null;
  modificadoPor: string | null = null;
  carregando = true;

  private travaExistente = false;

  constructor(
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<TravaContaCaixaDialogComponent>
  ) { }

  ngOnInit(): void {
    this.configuracaoCaixaApiService.getTrava(this.conta.id).subscribe({
      next: (trava) => {
        if (trava) {
          this.dataTrava = new Date(trava.dataTrava);
          this.modificadoPor = trava.modificadoPor;
          this.travaExistente = true;
        }
        this.carregando = false;
      }
    });
  }

  public salvarClick(): void {
    if (this.dataTrava) {
      this.configuracaoCaixaApiService.setOrUpdateTrava(this.conta.id, this.dataTrava).subscribe({
        next: () => {
          this.messageService.showToastSuccess('Trava definida com sucesso.');
          this.dialogRef.close(true);
        }
      });
    } else if (this.travaExistente) {
      this.configuracaoCaixaApiService.removerTrava(this.conta.id).subscribe({
        next: () => {
          this.messageService.showToastSuccess('Trava removida com sucesso.');
          this.dialogRef.close(true);
        }
      });
    } else {
      this.dialogRef.close(false);
    }
  }
}
